export default __webpack_public_path__ + "static/media/icon-trophy-gold.3c5a2641.svg";